import { render, staticRenderFns } from "./ContainerSuggestion.vue?vue&type=template&id=8dad7ff4&"
import script from "./ContainerSuggestion.vue?vue&type=script&lang=js&"
export * from "./ContainerSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports